// extracted by mini-css-extract-plugin
export default {"wrapper":"Section_wrapper__pPfMP","content":"Section_content__nXfhB"};